
<sh-grid id="psm-grid-1">
  <div columns='4' col-m='12'>
    <app-psm-pattern-details >
    </app-psm-pattern-details>
  </div>
  <div columns='8' col-m='12' style="display: flex;">
    @if (isPSMLoading) {
      <sh-spinner id="psm-spinner-2" style="align-self: center;" size="s"></sh-spinner>
    }
    @if (visuals && !isPSMLoading) {
      <sh-grid id="psm-grid-3" fit-content="true" style="gap: 12px;">
        @for (viz of visuals | visualOrder; track viz.name) {
          <div [attr.columns]="getVisualSize(visuals)">
            <!-- <sh-text id="psm-text-4" size="title-1">{{ viz.title }}</sh-text> -->
            <app-powerbi style="height: 100%; width: 100%" [token]="token"
              [reportid]="report['id']" [visualid]="viz.name" [title]="viz.title ? '' : ''" [subtitle]="''" [pageid]="report['name']" [groupid]="report['groupId']"
              [filters]="filters">
            </app-powerbi>
          </div>
        }
      </sh-grid>
    }
    @if (isPSMLoading == false && visuals?.length === 0) {
      <sh-card id="psm-card-5" style="margin-top: 12px;">
        <sh-empty-state id="psm-empty-state-6" icon='analytics' [attr.label]="'psm.modal.noVisuals' | transloco">
        </sh-empty-state>
      </sh-card>
    }
  </div>
</sh-grid>